import clsx from 'clsx';
import style from './style.module.scss';

export const Skeleton = ({ height, width, ...props }) => {
    return (
        <div {...props} className={clsx(style.skeleton, props.className)} style={{ height: height, width: width }} />
    );
};
